import React, { useState } from 'react';
import { useCookiePreferences, useAnalytics } from '../../components';
import { ButtonTrigger, Heading, Form, Label, CookieBlock, Description, CookieHeading, Checkbox } from './styled';
import { Modal } from '../Modal';
export function CookiePreferences({ id, type, heading, requiredCookiesHeading, requiredCookiesBody, optionalCookiesHeading, optionalCookiesBody, preferencesButtonText, onClose }) {
    const [isOpen, setIsOpen] = useState(false);
    const { hasGdprConsented, setGdprConsent, hasOptedOut, isGdprUser } = useCookiePreferences();
    const { sendTrackEvent } = useAnalytics();
    const close = () => {
        setIsOpen(false);
        if (isGdprUser && !hasGdprConsented && !hasOptedOut) {
            setGdprConsent(false);
        }
        if (onClose) {
            onClose();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonTrigger, { type: "button", onClick: () => {
                setIsOpen(true);
                sendTrackEvent('clickedCookiePreferences', {
                    event: 'clicked',
                    eventComponent: 'cookiePreferences',
                    eventContainer: type,
                    label: preferencesButtonText
                });
            } }, preferencesButtonText),
        React.createElement(Modal, { modal: {
                id,
                content: {
                    transitionType: 'SlideDown FadeOut',
                    transitionSpeed: 'Fast',
                    modalSize: 'Small',
                    closeText: 'Close (Esc)'
                }
            }, isOpen: isOpen, close: close },
            React.createElement(Form, null,
                React.createElement(Heading, null, heading),
                React.createElement(CookieBlock, null,
                    React.createElement(Label, null,
                        React.createElement("div", null,
                            React.createElement(Checkbox, { type: "checkbox", checked: true, disabled: true })),
                        React.createElement(CookieHeading, null, requiredCookiesHeading)),
                    React.createElement(Description, null, requiredCookiesBody)),
                React.createElement(CookieBlock, null,
                    React.createElement(Label, null,
                        React.createElement("div", null,
                            React.createElement(Checkbox, { type: "checkbox", checked: hasGdprConsented, onChange: (event) => {
                                    event.target.checked
                                        ? setGdprConsent(true)
                                        : setGdprConsent(false);
                                } })),
                        React.createElement(CookieHeading, null, optionalCookiesHeading)),
                    React.createElement(Description, null, optionalCookiesBody))))));
}
//# sourceMappingURL=CookiePreferences.js.map